{
    // BUTTONS
    const CHANGE_ADDRESS = 'change-address-button';
    const CANCEL = 'cancel-button';
    const ACCEPT_AND_RESEND = 'accept-and-resend-button';
    const RESEND = 'resend-button';

    // FORM DATA
    const CONFIRMATION_MESSAGE_PART_1 = 'confirmation-message-part1';
    const CONFIRMATION_MESSAGE_PART_1_EMAIL_UNCHANGED = 'confirmation-message-part1-email-unchanged';
    const CONFIRMATION_MESSAGE_PART_2 = 'confirmation-message-part2';
    const ERROR_UPDATING = 'error-updating';
    const EMAIL_OR_TELEPHONE_CHANGED = 'email-or-telephone-changed';


    $(() => {
        const handleClick = (...buttons) => (handler) => {
            const selector = buttons
                .flatMap((btn) => [
                    `.update-order-details .${btn}`,
                    `.updateorderdetails-form .${btn}`
                ])
                .join(', ');

            $(selector).on('click', handler);
        };

        handleClick(CHANGE_ADDRESS, CANCEL)((event) => {
            const $button = getButton(event);

            toggleEmailAndTelephoneEditing($button);
        });

        handleClick(ACCEPT_AND_RESEND, RESEND)((event) => {
            const $button = getButton(event);
            const $form = $button.closest('.row').find('form');
            const emailOrTelephoneChanged = $button.hasClass(ACCEPT_AND_RESEND);

            if (emailOrTelephoneChanged) {
                $form.data(EMAIL_OR_TELEPHONE_CHANGED, true);
            }

            $form.submit();
        });

        function getButton(event) {
            return $(event.currentTarget);
        }
    });


    Object.assign(window, {
        validateEmailAddressOrTelephoneForUpdateOrderDetails() {
            const $form = $(this);

            if (!$form.valid()) {
                return false;
            }
        },

        successChangeEmailOrTelephoneForSalesOrderItem({ EmailAddress, Telephone, Outcome, Message }) {
            const $form = $(this);
            const $details = $form.find('.change-order-details');
            let emailOrTelephoneChanged;

            if (Outcome === 'Success') {
                emailOrTelephoneChanged = $form.data(EMAIL_OR_TELEPHONE_CHANGED);
                updateEmailAndTelephone();
                showSuccessAlert();
            } else {
                showError();
            }

            function updateEmailAndTelephone() {
                if (emailOrTelephoneChanged) {
                    $form.data(EMAIL_OR_TELEPHONE_CHANGED, false);
                    $details.find('.email-address-field, .email-address')
                        .text(EmailAddress);
                    $details.find('.telephone-field, .telephone')
                        .text(Telephone);
                    toggleEmailAndTelephoneEditing($form);
                }
            }

            function showSuccessAlert() {
                const messageLine1 = emailOrTelephoneChanged
                    ? $form.data(CONFIRMATION_MESSAGE_PART_1)
                    : $form.data(CONFIRMATION_MESSAGE_PART_1_EMAIL_UNCHANGED);
                const messageLine2 = $form.data(CONFIRMATION_MESSAGE_PART_2);

                if (messageLine1 && messageLine2) {
                    showDecodedAlert(messageLine1 + '\r\n\r\n' + messageLine2)
                }
            }

            function showError() {
                const alertMessage = $form.data(ERROR_UPDATING);

                if (alertMessage) {
                    $details.find('.email-address-validation')
                        .append(`<p class="error">${alertMessage}</p>`);
                    showDecodedAlert(alertMessage);
                } else {
                    $details.find('.email-address-editor .field-validation-error').show();
                }

                console.error(Message);
            }
        }
    });

    function toggleEmailAndTelephoneEditing($el) {
        const $row = $el.closest('.row');
        const selector = [
            '.action-button-wrapper',
            '.email-address-editor',
            '.email-address-field',
            '.email-address',
            '.telephone-editor',
            '.telephone-field',
            '.telephone'
        ].join(', ');

        const $emailInput = $row.find('.email-address-editor input');
        $emailInput.val($emailInput.data('original-email'));
        $emailInput.focusout(); // Clears validation state

        const $telephoneInput = $row.find('.telephone-editor input');
        $telephoneInput.val($telephoneInput.data('original-telephone'));
        $telephoneInput.focusout(); // Clears validation state

        $row.find(selector).toggle();
    }

    function showDecodedAlert(textToDecode) {
        alert($('<textarea />').html(textToDecode).text());
    }
}
